











import Vue, { PropType } from "vue";
import LanguageGrid from "../../molecules/LanguageGrid/LanguageGrid.vue";
import Logo from "../../atoms/Logo/Logo.vue";
import { Option } from "@/store/models";

export default Vue.extend({
  name: "LanguagePage",
  components: {
    LanguageGrid,
    Logo
  },
  props: {
    options: Array as PropType<Option[]>,
    isDisabled: Boolean,
    logoUrl: String
  }
});
